// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"4eb97592","404":"2fdfe97c","787":"54d3ab17"}[chunkId] + ".chunk.js";
};